import Home from "./views/Home.vue";
import Freebets from "./views/Freebets.vue";
import FreeBetCampaignGenerator from "./components/FreeBetCampaignGenerator.vue";
import Rains from "./views/Rains.vue";
import RainCampaignGenerator from "./components/RainCampaignGenerator.vue";
import Challenges from "./views/Challenges.vue";
import ChallengesGenerator from "./components/ChallengeGenerator.vue";
import Exports from "../views/Exports.vue";
import Chat from "../views/Chat.vue";
import Players from "./views/Players.vue";
import Promotions from "./views/Promotions.vue";
import LoyaltyPoints from "./views/LoyaltyPoints.vue";
import LoyaltyPointsGenerator from "./components/LoyaltyPointsGenerator.vue";

export const slotRoutes = [
  {
    path: "/:lang?/:skinFilt(\\d+)?/slot",
    component: Home,
    meta: { requiresAuth: true, hiddenBreadcrumb: true, section: "slot" },
    name: "Home",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/freebets/:id/edit",
    component: FreeBetCampaignGenerator,
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
    name: "FreebetsEdit",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/freebets/create",
    component: FreeBetCampaignGenerator,
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
    name: "FreebetsCreate",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/freebets/:id?",
    component: Freebets,
    meta: { requiresAuth: true, section: "slot" },
    name: "Freebets",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/rains/:id/edit",
    component: RainCampaignGenerator,
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
    name: "RainsEdit",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/rains/create",
    component: RainCampaignGenerator,
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
    name: "RainsCreate",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/rains/:id?",
    component: Rains,
    meta: { requiresAuth: true, section: "slot" },
    name: "Rains",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/challenges/:id/edit",
    component: ChallengesGenerator,
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
    name: "ChallengesEdit",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/challenges/create",
    component: ChallengesGenerator,
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
    name: "ChallengesCreate",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/challenges/:id?",
    component: Challenges,
    meta: { requiresAuth: true, section: "slot" },
    name: "Challenges",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/export",
    name: "ExportPage",
    component: Exports,
    meta: { requiresAuth: true, section: "slot" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/chat",
    component: Chat,
    name: "ChatPage",
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "slot",
    },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/players/:id?",
    component: Players,
    meta: { requiresAuth: true, section: "slot" },
    name: "Players",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/promotions/:id?",
    component: Promotions,
    meta: { requiresAuth: true, section: "slot" },
    name: "Promotions",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/loyalty-coins/create",
    component: LoyaltyPointsGenerator,
    meta: {
      requiresAuth: true,
      section: "slot",
    },
    name: "LoyaltyCoinsCreate",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/loyalty-coins/:id/edit",
    component: LoyaltyPointsGenerator,
    meta: {
      requiresAuth: true,
      section: "slot",
    },
    name: "LoyaltyCoinsEdit",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/slot/loyalty-coins/:id?",
    component: LoyaltyPoints,
    meta: { requiresAuth: true, section: "slot" },
    name: "LoyaltyCoins",
  },
];
